<template lang="html">
  <div class="rating-wrapper">
    <div v-for="index in 5" :key="index" class="image-wrapper">
      <img
        v-if="index <= full"
        src="@/assets/newImges/icons/fullStar.svg"
        alt="star image"
      />
      <img
        v-else-if="half && index === full + 1"
        src="@/assets/newImges/icons/halfStar.svg"
        alt="half star image"
      />
      <img
        v-else
        src="@/assets/newImges/icons/emptyStar.svg"
        alt="empty star image"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "rating",
  props: {
    rating: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      full: 0,
      half: 0
    };
  },
  watch: {
    rating() {
      this.setStars();
    }
  },
  mounted() {
    this.setStars();
  },
  methods: {
    setStars() {
      if (this.rating % 1 !== 0) {
        this.half = 1;
      }
      this.full = Math.floor(this.rating);
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-wrapper {
  display: flex;
  flex-direction: row;
  .star {
    user-select: none;
  }
  .image-wrapper {
    padding-right: 5px;
  }
  .image-wrapper:last-child {
    padding-right: 0px;
  }
}
</style>
